import React from 'react';
import { Switch } from '@headlessui/react';
import { connectionDetailsClasses } from '../../common/tailwindClassnames';

interface CustomCheckboxProps {
    schema?: any;
    value: any;
    label: string;
    checked: boolean;
    itemsData: any;
    enumItem: any;
    onChange: (updatedItems: boolean | any[]) => void;
    formData: any;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
    schema,
    value,
    label,
    checked,
    itemsData,
    enumItem,
    onChange,
    formData
}) => {
    const isChecked = Array.isArray(formData)
        ? formData.includes(enumItem)
        : formData ?? value ?? checked ?? false;

    const handleChange = (checked: boolean) => {
        const updatedItems = Array.isArray(formData)
            ? (checked
                ? [...formData, enumItem]
                : formData.filter((item: any) => item !== enumItem))
            : checked;
        onChange(updatedItems);
    };

    const fieldLabel = schema?.title || label;
    return (
        <div className="flex items-center w-full justify-between">
            <span className="text-neutral-gray-900 dark:text-white whitespace-nowrap">{fieldLabel}</span>
            <Switch
                checked={isChecked}
                onChange={handleChange}
                className={`
                    ${connectionDetailsClasses?.switchContainer || ''}
                    ${isChecked
                        ? 'bg-status-green focus:ring-status-green/50'
                        : 'bg-secondary-gray focus:ring-secondary-gray/50'
                    }
                `}
                aria-label={fieldLabel}
            >
                <span className="sr-only">{isChecked ? 'Enabled' : 'Disabled'}</span>
                {/* X icon (right) */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute right-2 top-1.5 h-4 w-4 text-white transition-opacity duration-200"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                {/* Checkmark icon (left) */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute left-2 top-1.5 h-4 w-4 text-white transition-opacity duration-200"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                {/* The moving button (without icons) */}
                <span
                    aria-hidden="true"
                    className="pointer-events-none inline-block size-5 translate-x-0 rounded-full bg-white ring-0 shadow-lg transition duration-200 ease-in-out group-data-[checked]:translate-x-7"
                />
            </Switch>
        </div>
    );
};

export default CustomCheckbox;